import { STORE_ENTITIES } from '@app/constants'
import { App_User_App } from '@app/types'

export class Set_User_App {
  public static readonly type = `[${STORE_ENTITIES.USER_APP}] Set User App`
  constructor(public payload: Partial<App_User_App>) { }
}
